import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { VisuallyHidden } from "@/components/ui/visually-hidden";

interface MintModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedChain: string;
}

const THIRDWEB_IFRAMES = {
  base: `<iframe
    src="https://embed.ipfscdn.io/ipfs/bafybeicd3qfzelz4su7ng6n523virdsgobrc5pcbarhwqv3dj3drh645pi/?contract=0x07e9324b757F1846a1c4f17832757eb64D6Eb6aD&chain=%7B%22name%22%3A%22Base%22%2C%22chain%22%3A%22ETH%22%2C%22rpc%22%3A%5B%22https%3A%2F%2F8453.rpc.thirdweb.com%2F%24%7BTHIRDWEB_API_KEY%7D%22%5D%2C%22nativeCurrency%22%3A%7B%22name%22%3A%22Ether%22%2C%22symbol%22%3A%22ETH%22%2C%22decimals%22%3A18%7D%2C%22shortName%22%3A%22base%22%2C%22chainId%22%3A8453%2C%22testnet%22%3Afalse%2C%22slug%22%3A%22base%22%2C%22icon%22%3A%7B%22url%22%3A%22ipfs%3A%2F%2FQmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv%22%2C%22width%22%3A1200%2C%22height%22%3A1200%2C%22format%22%3A%22png%22%7D%7D&clientId=3e5888d69bd874e256e5800546dbbe80&theme=dark&primaryColor=purple"
    width="100%"
    height="750px"
    style="max-width:100%;"
    frameborder="0"
  ></iframe>`,
  pulsechain: `<iframe
    src="https://embed.ipfscdn.io/ipfs/bafybeicd3qfzelz4su7ng6n523virdsgobrc5pcbarhwqv3dj3drh645pi/?contract=0xAD010CA83aCF225b4D11109ef925f120A37de7e9&chain=%7B%22name%22%3A%22PulseChain%22%2C%22chain%22%3A%22PLS%22%2C%22rpc%22%3A%5B%22https%3A%2F%2F369.rpc.thirdweb.com%2F%24%7BTHIRDWEB_API_KEY%7D%22%5D%2C%22nativeCurrency%22%3A%7B%22name%22%3A%22Pulse%22%2C%22symbol%22%3A%22PLS%22%2C%22decimals%22%3A18%7D%2C%22shortName%22%3A%22pls%22%2C%22chainId%22%3A369%2C%22testnet%22%3Afalse%2C%22slug%22%3A%22pulsechain%22%7D&clientId=3e5888d69bd874e256e5800546dbbe80&theme=dark&primaryColor=purple"
    width="100%"
    height="750px"
    style="max-width:100%;"
    frameborder="0"
  ></iframe>`,
  chia: "https://mintgarden.io/collections/col1etvtg9y9xj0tq57nz25grk5d4la5j2v85zyff0j5hxpn5kt7zdzst8wmvc"
} as const;

export function MintModal({ open, onOpenChange, selectedChain }: MintModalProps) {
  const content = THIRDWEB_IFRAMES[selectedChain as keyof typeof THIRDWEB_IFRAMES];

  // If it's Chia, redirect to MintGarden
  if (selectedChain === 'chia' && open) {
    window.open(content, '_blank');
    onOpenChange(false);
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[800px] p-0">
        <VisuallyHidden>
          <DialogTitle>Mint Cryptfluencer NFT</DialogTitle>
        </VisuallyHidden>
        <div dangerouslySetInnerHTML={{ __html: content || '' }} />
      </DialogContent>
    </Dialog>
  );
}